module.exports = __webpack_public_path__ + "static/media/check-green.a0fd83da.svg";